<template>
  <div class="page">
    <div class="wrapper header">
      <div class="expand"></div>
      <img src="../assets/ic_logo_pc.png" class="logo" />
      <div class="expand"></div>
    </div>
    <div class="main">
      <div class="expand"></div>
      <img src="../assets/bg_screenshot.png" class="img-show" />
      <div class="content">
        <dl>
          <br />
          <dd>微端包体秒速下载</dd>
          <dd>装备、战力、好友 精彩依旧</dd>
          <br />
          <dd>随时随地</dd>
          <dd>感受“征途”魅力</dd>
          <br />
        </dl>
      </div>
      <div class="expand"></div>
      <div class="download" style="height: auto; padding: 37px 0 30px">
        <div class="expand"></div>
        <div class="item">
          <span>iOS</span>
          <div class="icon">
            <img src="../assets/iOS.png" class="download_type_img" />
          </div>
          <div class="links">
            <!-- <a class="link-url">敬请期待</a> -->
            <!-- <a class="link-url" :href="iOS">App Store下载</a> -->
            <a class="link-url" :href="iOSUrl">企业版下载</a>
          </div>
        </div>
        <div class="v_line"></div>
        <div class="item">
          <span>Android</span>
          <div class="icon">
            <img src="../assets/android.png" class="download_type_img" />
          </div>
          <div class="links">
            <a class="link-url" :href="androidUrl">微端包 {{ androidSize }}</a>
          </div>
        </div>
        <div class="item">
          <span>HTML5</span>
          <div class="icon">
            <img src="../assets/html5.png" class="download_type_img" />
          </div>
          <div class="links">
            <a class="link-url">敬请期待</a>
            <!-- <a class="link-url" :href="html5Url">网页版</a> -->
          </div>
        </div>
        <div class="v_line"></div>
        <div class="item">
          <span>二维码</span>
          <div class="icon">
            <img src="../assets/qr.png" class="download_type_img" />
          </div>
          <div class="links">扫一扫下载客户端</div>
        </div>

        <div class="expand"></div>
      </div>
    </div>

    <div class="wrapper footer">
      <div class="content">
        <div>
          <img src="../assets/ic_logo_title_pc.png" height="70px" />
        </div>
        <span>COPYRIGHT @ 2019 GIANT. 巨人网络 版权所有</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PC",
  props: {
    androidUrl: String,
    iOSUrl: String,
    androidSize: String,
    html5Url: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header img {
  display: block;
  height: 5rem;
}

.header .logo {
}

.wrapper {
  width: 100%;
  min-width: 1170px;
}

.wrapper.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 6rem;
  background: #333a42;
}

.page {
  display: flex;
  flex-direction: column;
}

.main {
  display: flex;
  align-items: center;
  margin-top: 2rem;
}

.expand-header {
  flex-grow: 0.26;
}

.expand {
  flex-grow: 1;
  flex: 1;
}

.main .img-show {
  width: 21rem;
}

.main .content {
  margin-left: 1rem;
  text-align: left;
}

.main dt {
  font-size: 18px;
  font-weight: 700;
  margin-left: 2rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.main dd {
  font-size: 20px;
}

.download {
  display: flex;
  align-items: left;
  margin-top: 1rem;
}

.download .v_line {
  width: 1px;
  height: 10rem;
  background-color: #eaeaea;
}

.download .item {
  margin-left: 4rem;
  margin-right: 4rem;
  display: flex;
  flex-direction: column;
  align-self: flex-start;
}

.download .item span {
  font-size: 1.4rem;
  margin-bottom: 1rem;
}

.download .item .download_type_img {
  height: 84px;
}

.download .item .links {
  font-size: 0.75rem;
  color: #333333;
  margin: 0.5rem;
}

.links a,
.links a:focus,
.links a:hover {
  color: #525252;
  border: 1px solid #8e8e8e;
  border-radius: 5px;
  padding: 10px 20px;
  text-decoration: none;
  display: inline-block;
  margin-bottom: 8px;
}

.link-url:active,
.link-url:hover {
  background-color: #eaeaea;
}

.wrapper.footer {
  margin-top: 1rem;
  height: 8rem;
  color: #4b4b4b;
  background: #292d32;
}

.wrapper.footer .content {
  display: flex;
  flex-direction: column;
  align-self: center;
  padding-top: 1rem;
}
</style>
